import React from 'react'
import agent2 from './agent2.png'
import { Link } from 'react-router-dom'

const insuranceplan=()=> {
  return (
    <div>
      <>
      <div id='become' className=''>

     
<div className='container my-3'>
  <div className='row'>
      <div className='col-md-6'>
          <h1>Get Affordable <strong>Insurance Plans</strong></h1>
          <p>Unit plans are investment plans for those who realise the worth of hard-earned money. These plans help you see your savings yield rich benefits and help you.

</p>
<div className='mt-3'>
          <Link to='/Services' className='btn btn-success'>Great A Quote</Link>

        </div>

      </div>
      <div className='col-md-6'>
          <img src={agent2} className='animated' alt=''/>


      </div>

  </div>
  </div>

</div>
      </>
    </div>
  )
}

export default insuranceplan
